import { createFileRoute } from "@tanstack/react-router";
import SaintTmsInsuranceCoverageGoogle from "@/pages/SaintTmsInsuranceCoverageGoogle";
export const Route = createFileRoute("/saint-tms-insurance-coverage-google")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "SAINT® TMS Insurance Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SAINT® TMS insurance coverage at Neuro Wellness in Coral Springs, FL. We verify your benefits for free. Commercial plans and Medicare may cover treatment.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS Insurance Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SAINT® TMS insurance coverage at Neuro Wellness in Coral Springs, FL. We verify your benefits for free. Commercial plans and Medicare may cover treatment.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/saint-tms-insurance-coverage-google",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-tms-insurance-coverage-google",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintTmsInsuranceCoverageGoogle />;
}
